import { useTranslation } from "react-i18next";

const reviews = [
  {
    name: "Александър П.",
    country: "България",
    flag: "🇧🇬",
    contract: "B",
    invested: 50123,
    yield: 97,
    text: "Получих изплащането точно на третия работен ден. Невероятна скорост и прозрачност. Вече съм в третия си контракт с ARTEMIDA.",
    stars: 5,
  },
  {
    name: "Алексей К.",
    country: "Россия",
    flag: "🇷🇺",
    contract: "C",
    invested: 72434,
    yield: 113,
    text: "Скептически относился поначалу, но выплата пришла через 2 рабочих дня. Доходность 113% — это реально. Рекомендую всем.",
    stars: 5,
  },
  {
    name: "Marco R.",
    country: "Italia",
    flag: "🇮🇹",
    contract: "A",
    invested: 38965,
    yield: 68,
    text: "Ho ricevuto il pagamento in tempo. Il processo è stato semplice e trasparente. Sono molto soddisfatto del rendimento del 68%.",
    stars: 5,
  },
  {
    name: "James W.",
    country: "United Kingdom",
    flag: "🇬🇧",
    contract: "B",
    invested: 50123,
    yield: 97,
    text: "Exceptional returns and fast payout. The SpaceX backing gives real confidence. Already reinvested into Contract C.",
    stars: 5,
  },
  {
    name: "Hans M.",
    country: "Deutschland",
    flag: "🇩🇪",
    contract: "C",
    invested: 72434,
    yield: 113,
    text: "Sehr beeindruckend. Die Auszahlung erfolgte pünktlich und die Rendite von 113% ist außergewöhnlich. Klare Empfehlung.",
    stars: 5,
  },
  {
    name: "Pierre D.",
    country: "France",
    flag: "🇫🇷",
    contract: "A",
    invested: 38965,
    yield: 68,
    text: "Excellent service, paiement reçu en 3 jours ouvrables comme promis. Le lien avec SpaceX rend ce projet très crédible.",
    stars: 5,
  },
];

export default function ReviewsSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-32 bg-[#050810]">
      <div className="absolute inset-0 opacity-8" style={{ backgroundImage: "radial-gradient(circle at 20% 50%, rgba(255,180,0,0.15) 0%, transparent 50%)" }} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
            <span className="text-amber-400 text-[10px] md:text-xs tracking-[0.3em] uppercase" style={{ fontFamily: "'Orbitron', sans-serif" }}>
              {t("reviews_badge")}
            </span>
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white mb-3 md:mb-4" style={{ fontFamily: "'Orbitron', sans-serif" }}>
            {t("reviews_title")}
          </h2>
          <p className="text-white/40 text-xs md:text-sm max-w-xl mx-auto">{t("reviews_subtitle")}</p>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {reviews.map((r, i) => {
            const profit = Math.round(r.invested * r.yield / 100);
            return (
              <div
                key={i}
                className="group p-4 md:p-6 border border-white/10 rounded-lg bg-white/[0.02] hover:border-amber-400/25 hover:bg-white/[0.04] transition-all duration-300"
              >
                {/* Stars */}
                <div className="flex gap-1 mb-3 md:mb-4">
                  {Array.from({ length: r.stars }).map((_, si) => (
                    <i key={si} className="ri-star-fill text-amber-400 text-xs md:text-sm" />
                  ))}
                </div>

                {/* Review text */}
                <p className="text-white/60 text-xs md:text-sm leading-relaxed mb-4 md:mb-5 italic">
                  &ldquo;{r.text}&rdquo;
                </p>

                {/* Profit badge */}
                <div className="flex items-center gap-2 mb-4 md:mb-5 p-2.5 md:p-3 rounded-lg bg-emerald-400/5 border border-emerald-400/15">
                  <i className="ri-arrow-up-line text-emerald-400 text-sm flex-shrink-0" />
                  <div>
                    <span className="text-emerald-400 font-black text-xs md:text-sm" style={{ fontFamily: "'Orbitron', sans-serif" }}>
                      +{profit.toLocaleString("de-DE")} EUR
                    </span>
                    <span className="text-white/30 text-[10px] md:text-xs ml-1.5">({r.yield}% {t("calc_yield_label")})</span>
                  </div>
                </div>

                {/* Author */}
                <div className="flex items-center gap-2 md:gap-3 pt-3 md:pt-4 border-t border-white/5">
                  <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-amber-400/10 border border-amber-400/20 text-sm md:text-base flex-shrink-0">
                    {r.flag}
                  </div>
                  <div className="min-w-0">
                    <div className="text-white font-bold text-xs" style={{ fontFamily: "'Orbitron', sans-serif" }}>{r.name}</div>
                    <div className="text-white/30 text-[10px] truncate">{r.country} · {t("contract_tier_" + (r.contract === "A" ? "entry" : r.contract === "B" ? "growth" : "premium"))}</div>
                  </div>
                  <div className="ml-auto flex-shrink-0">
                    <span className="px-1.5 md:px-2 py-0.5 rounded-full text-[9px] md:text-xs border border-emerald-400/20 text-emerald-400 bg-emerald-400/5 whitespace-nowrap">
                      {t("reviews_verified")}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom stats */}
        <div className="mt-8 md:mt-12 grid grid-cols-3 gap-3 md:gap-4 max-w-2xl mx-auto">
          {[
            { value: "100+", label: t("reviews_stat1") },
            { value: "3", label: t("reviews_stat2") },
            { value: "98%", label: t("reviews_stat3") },
          ].map((s) => (
            <div key={s.label} className="text-center p-3 md:p-5 border border-white/10 rounded-lg bg-white/[0.02]">
              <div className="text-xl md:text-2xl font-black text-amber-400 mb-0.5 md:mb-1" style={{ fontFamily: "'Orbitron', sans-serif" }}>{s.value}</div>
              <div className="text-white/30 text-[9px] md:text-xs leading-tight">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
